import { Component, inject, Input } from '@angular/core';
import { StrapiService } from '../../services/strapi.service';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { Router } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { ToastrService } from 'ngx-toastr';
import { BypassSecurityPipe } from '../../pipes/bypass-security.pipe';

@Component({
  selector: 'app-contact-form',
  imports: [
    DynamicFormComponent,
    ToastrModule,
    BypassSecurityPipe
  ],
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.less'
})
export class ContactFormComponent {
  @Input() data: any;
  private router = inject(Router);
  loading: boolean = false;


  /**
   *
   */
  constructor(private strapiService: StrapiService, private toastr: ToastrService) {
    
  }

  onSubmit(formData: any) {
    this.loading = true;
        const labeledData = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => {
        // If it's a checkbox group (i.e. an object), filter only checked ones
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          const selected = Object.entries(value)
            .filter(([_, checked]) => checked)
            .map(([option]) => option);
          return [key, selected];
        }
        return [key, value];
      })
    );
  
      this.strapiService.sendContactMail(labeledData).subscribe({
      next: (res) => {
        this.loading = false;
        this.toastr.success('Bericht is verstuurd!', 'Succes');
      },
      error: (err) => {
        // Optionally handle error
        this.loading = false;
        this.toastr.error("Er is iets misgegaan.");
      }
    });
  }
}
